import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import axios from "axios";

export class Newsletter extends React.Component {
	constructor(props) {
		super(props);

		let showIcon = localStorage.getItem("removeNewsletterIcon");
		if (showIcon === null) {
			showIcon = sessionStorage.getItem("removeNewsletterIcon") ? false : true;
		} else {
			showIcon = false;
		}

		this.state = {
			showModal: false,
			showIcon,
			nombre: "",
			email: "",
			feedback: {
				status: "",
				message: ""
			}
		};
		this.handleSubmit = this.handleSubmit.bind(this);
		this.toggleModal = this.toggleModal.bind(this);
		this.hideIcon = this.hideIcon.bind(this);
		this.InputChange = this.InputChange.bind(this);
	}
	handleSubmit(e) {
		e.preventDefault();
		const { nombre, email } = this.state;
		axios
			.post(this.props.subscribeApi, {
				nombre,
				email
			})
			.then(() => {
				localStorage.setItem("removeNewsletterIcon", true);
				this.setState({
					feedback: {
						status: "success",
						message: this.props.translate.newsletter_subscribed
					}
				});
				setTimeout(() => {
					this.hideIcon();
				}, 4000);
			})
			.catch(req => {
				const { statusText } = req;
				console.log(req);
				this.setState({
					feedback: {
						status: "error",
						message:
							"Error: " + statusText ? statusText : "Intentalo nuevamente"
					}
				});
			});
	}
	toggleModal() {
		this.setState({
			showModal: !this.state.showModal
		});
	}
	hideIcon() {
		sessionStorage.setItem("removeNewsletterIcon", true);
		this.setState({
			showIcon: false
		});
	}
	InputChange(e) {
		this.setState({
			[e.target.name]: e.target.value
		});
	}
	render() {
		const { translate } = this.props;
		if (!this.state.showIcon) {
			return "";
		}
		return (
			<div className="Newsletter">
				<React.Fragment>
					{this.state.showModal ? (
						<form className="Newsletter-form" onSubmit={this.handleSubmit}>
							<h3>{translate.newsletter_title}</h3>
							<p>{translate.newsletter_body}</p>
							{this.state.feedback.status ? (
								<p className={`feedback ${this.state.feedback.status}`}>
									{this.state.feedback.message}
								</p>
							) : null}

							<button
								className="Newsletter-form-close"
								type="button"
								onClick={this.hideIcon}
							>
								<i className="fa fa-times" />
							</button>
							<input
								type="text"
								name="nombre"
								required
								value={this.state.nombre}
								onChange={this.InputChange}
								placeholder={translate.placeholder_nombre}
							/>
							<input
								type="email"
								name="email"
								required
								value={this.state.email}
								onChange={this.InputChange}
								placeholder={translate.placeholder_email}
							/>
							<button className="submit-form">{translate.subscribirse}</button>
							<div className="separador">
								<i className="fa fa-caret-down" aria-hidden="true" />
							</div>
						</form>
					) : null}
					<button onClick={this.toggleModal}>
						<span className="s_pomu_megafono" />
					</button>
				</React.Fragment>
			</div>
		);
	}
}
Newsletter.propTypes = {
	translate: PropTypes.object.isRequired // eslint-disable-line react/forbid-prop-types
};
Newsletter.defaultProps = {
	translate: {
		placeholder_nombre: "Nombre",
		placeholder_email: "Email",
		subscribirse: "Subscribirse",
		newsletter_title: "¡ Juegos nuevos en tu Email !",
		newsletter_body:
			"Recibe cada sábado en tu email los mejores juegos de la semana y las últimas novedades",
		newsletter_subscribed: "Te haz registrado en el newsletter correctamente"
	},
	subscribeApi: "/api/subscribe"
};
export default Newsletter;
